import emitAsync from '../utils/emitAsync';
import { useLoadingStore } from '../stores/useLoadingStore';

// =========================
// REQUESTS ATIVAS
// =========================

const activeRequests = new Set();

// =========================
// LOAD VEHICLES
// =========================

const {
  setLoadingVehicles,
  setLoadingFooter,
  setLoadingFooterTxt,
  setLoadProgress
} = useLoadingStore.getState();


export async function loadVehicles(socket) {

  if (!socket?.connected) {
    return false;
  }

  const requestId = crypto.randomUUID();

  activeRequests.add(requestId);

  try {

    // =========================
    // LOADING
    // =========================

    setLoadingVehicles(true);

    setLoadingFooter(true);

    setLoadingFooterTxt('Carregando veículos...');

    setLoadProgress(0);

    // =========================
    // REQUEST
    // =========================

    await emitAsync(
      socket,
      'veiculos:get',
      {
        requestId
      }
    );

    return true;

  } catch (err) {

    console.error(
      'Erro ao iniciar carregamento de veículos:',
      err
    );

    finishVehiclesRequest(requestId);

    return false;

  }

}

// =========================
// REQUEST ATIVA
// =========================

export function isVehiclesRequestActive(
  requestId
) {

  return activeRequests.has(requestId);

}

// =========================
// FINALIZA REQUEST
// =========================

export function finishVehiclesRequest(
  requestId
) {

    activeRequests.delete(requestId);

    if (activeRequests.size > 0) {
    return;
  }

  setLoadingVehicles(false);

  setLoadingFooter(false);

  setLoadingFooterTxt('Carregando...');

  setLoadProgress(100);

}

// =========================
// LIMPA REQUESTS
// =========================

export function clearVehiclesRequests() {

  activeRequests.clear();

  setLoadingVehicles(false);

  setLoadingFooter(false);

  setLoadingFooterTxt('Carregando...');

  setLoadProgress(100);

}